import { Box, Flex, Group } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import Button from 'components/Button';
import P1Medium from 'components/typography/P1Medium';
import { useDashboardLayout } from 'layouts/dashboard/use-dashboard-layout';
import { noop } from 'lodash';
import { ReactNode, useMemo } from 'react';

interface BulkActionsBarProps {
  bulkActions?: ReactNode;
  selectedRowsCount?: number;
  onDeselectAll?: () => void;
}

/**
 * Displays a bar with bulk actions for the selected rows in the table.
 */
export default function BulkActionsBar({ bulkActions, selectedRowsCount, onDeselectAll = noop }: BulkActionsBarProps) {
  const { padding, tableBulkActionsHeight, tableBulkActionsTop } = useDashboardLayout();

  const style = useMemo(
    () => ({
      zIndex: 200,
      borderTop: '2px solid var(--mantine-color-gray-1)',
      borderBottom: '2px solid var(--mantine-color-gray-1)',
      borderLeft: '2px solid white',
      borderRight: '2px solid white',
    }),
    []
  );

  return (
    <Box
      pos="absolute"
      top={tableBulkActionsTop}
      left={0}
      w="100%"
      h={tableBulkActionsHeight}
      bg="#F6F6F8"
      px={padding}
      style={style}
      sx={{
        overflowX: 'auto',
        overflowY: 'hidden',
      }}
    >
      <Flex align="center" justify="space-between" gap={16} h="100%" miw="100%" w="max-content">
        <Group spacing={12} noWrap>
          {bulkActions}
        </Group>
        <Group spacing={8} noWrap>
          <P1Medium color="gray.8">vybrané: {selectedRowsCount}</P1Medium>
          <Button variant="tertiary" size="sm" leftIcon={<IconX strokeWidth={1.5} size={16} />} onClick={onDeselectAll}>
            Odznačiť všetko
          </Button>
        </Group>
      </Flex>
    </Box>
  );
}
